import type {
  StatTypeData,
  StatTypesTableColumns
} from '@library/types/statType';
import type { TableColumn } from '@library/types/utils';

export const STAT_TYPES_TABLE_HEADER: Array<
  TableColumn<StatTypesTableColumns>
> = [
  {
    column: 'checkbox',
    essential: true,
    label: '',
    sortEnabled: false,
    width: 'w-[3%] px-3'
  },
  {
    column: 'id',
    essential: true,
    label: 'ID',
    sortEnabled: true,
    width: 'w-[10%] px-3'
  },
  {
    column: 'name',
    essential: true,
    label: 'Name',
    sortEnabled: true,
    width: 'w-[20%] px-3'
  },
  {
    column: 'short_name',
    essential: true,
    label: 'Short Name',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  },
  {
    column: 'rank',
    essential: true,
    label: 'Rank',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  },
  {
    column: 'leagues',
    essential: true,
    label: 'Leagues',
    sortEnabled: false,
    width: 'w-[15%] px-3'
  },
  {
    column: 'lfg_ignored_leagues',
    essential: true,
    label: 'LFG Ignored Leagues',
    sortEnabled: false,
    width: 'w-[15%] px-3'
  },
  {
    column: 'stat_selectors',
    essential: true,
    label: 'Stat Selectors',
    sortEnabled: false,
    width: 'w-[15%] px-3'
  },
  {
    column: 'created_at',
    essential: true,
    label: 'Created At',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  },
  {
    column: 'updated_at',
    essential: true,
    label: 'Updated At',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  }
];

export const DEFAULT_STAT_TYPE_DATA: StatTypeData = {
  createdAt: '',
  earlySettleBuffer: '',
  earlySettleBufferDelay: '',
  postGameSettleBuffer: '',
  postGameSettleBufferDelay: '',
  id: '',
  leagueNames: '',
  lfgIgnoredLeagues: '',
  name: '',
  postGameFinalizationBuffer: '',
  rank: '',
  scoredPeriods: '',
  selectorLength: '',
  selectorStart: '',
  shortName: '',
  statSelectors: '',
  updatedAt: '',
  leagueIds: ''
};
